import { useEffect } from 'react';
import DOMPurify from 'dompurify';
import CircleStyleTextBox from '../circleStyleTextBox/circleStyleTextBox';
import styles from './battery.module.css';


const Battery = ({ m2sText }) => {
  return (
    <div className={`${styles.ctn} m2s-section fullscreen m2s-battery-ctn`}>
            <div className={styles.imgBox}>
        <img
          src="https://bucket.zhiyun-tech.com/detail/m2s/m2s-power.png"
          alt=""
          className={styles.img}
        />
      </div>
      <div className={styles.box}>
        <CircleStyleTextBox>
          {/* <h4>支持PD快充协议</h4> */}
          <h2
            className={`${styles.h} m2s-battery-h`}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(m2sText['text24']),
            }}
          ></h2>
          <h5>{m2sText['text25']}</h5>

          <h6>{m2sText['text26']}</h6>
        </CircleStyleTextBox>
      </div>

    </div>
  );
};

export default Battery;
